import { Nullable } from '@/shared/types/app.types'

export interface StatisticalAnalysisViewDetailChartFilterAxisCombo {
    id: string
    text: string
    icon?: string
}

export interface StatisticalAnalysisViewDetailChartFilterAxisModelAxis {
    list: StatisticalAnalysisViewDetailChartFilterAxisCombo[]
    selected: Nullable<StatisticalAnalysisViewDetailChartFilterAxisCombo>
}

export interface StatisticalAnalysisViewDetailChartFilterAxisModelTypes {
    show: boolean
    mainCombo?: StatisticalAnalysisViewDetailChartFilterAxisModelAxis
    associatedCombo?: StatisticalAnalysisViewDetailChartFilterAxisModelAxis
}

export interface StatisticalAnalysisViewDetailChartFilterAxisXY {
    yAxis: StatisticalAnalysisViewDetailChartFilterAxisModelTypes
    xAxis: StatisticalAnalysisViewDetailChartFilterAxisModelTypes
}

export interface StatisticalAnalysisViewDetailChartFilterAxisState {
    loading: boolean
    yAxis: StatisticalAnalysisViewDetailChartFilterAxisModelTypes
    xAxis: StatisticalAnalysisViewDetailChartFilterAxisModelTypes
}
export const initialStatisticalAnalysisViewDetailChartFilterAxisState =
    (): StatisticalAnalysisViewDetailChartFilterAxisState => ({
        loading: false,
        yAxis: {
            show: true,
            mainCombo: {
                list: [],
                selected: null
            }
        },
        xAxis: {
            show: true,
            mainCombo: {
                list: [],
                selected: null
            },
            associatedCombo: {
                list: [],
                selected: null
            }
        }
    })
